// Grid

'use strict'

import Util from "./Util";
const util = new Util();

export default class {
  constructor(id, row, color){
    let me = this;

    me.id = id;
    me.colNum = 4;
    me.rowNum = row;
    me.color = color;

    me.canvas = document.createElement('canvas');
    me.container = document.getElementById(me.id);
    me.context = me.canvas.getContext('2d');
    
    me.container.appendChild(me.canvas);

    me.xLinePoint = [];
    me.yLinePoint = [];

    me.x = 0;
    me.y = 0;
    me.speed = 12;

    me.contentSpacing = 102;
    if( util.is._bp60 ){
      me.contentSpacing = 32;
    }
    if( util.is._bp40 ){
      me.contentSpacing = 16;
    }

    me.init();

    let timer = 0;
    window.addEventListener('resize', (e) => {
      me.clearPoint();
      me.clearCanvas();

      clearTimeout(timer);

      timer = setTimeout(function(){
        me.init();
        me.draw();
      }, 200);
    });

    window.addEventListener('click', (e) => {
      // me.anime();
    });
  }

  init(){
    let me = this;

    me.set();
    me.setPoint();
  }

  set(){
    let me = this;

    me.canvas.width = me.container.clientWidth * window.devicePixelRatio;
    me.canvas.height = me.container.clientHeight * window.devicePixelRatio;

    me.canvas.style.width = me.container.clientWidth + 'px';
    me.canvas.style.height = me.container.clientHeight + 'px';
    // me.context.scale(0.5,0.5);

    me.scrollBarWidth = window.innerWidth - document.body.clientWidth;
    me.colSize = (window.innerWidth - me.contentSpacing*2 - me.scrollBarWidth) / 4;

    me.setStrokeStyle();
  }

  setStrokeStyle(){
    let me = this;

    me.context.strokeStyle = me.color;
    me.context.lineWidth = 1;
  }

  setPoint(){
    let me = this;

    me.xLinePoint.push(me.contentSpacing*window.devicePixelRatio);
    for(let i=1; i<=me.colNum; i++){
      let n = me.contentSpacing + me.colSize*i;
      n = n * window.devicePixelRatio;
      me.xLinePoint.push(n);
    }
  
    for(let i=1; i<=me.rowNum; i++){
      let n = me.colSize*i;
      n = n * window.devicePixelRatio;
      me.yLinePoint.push(n);
    }
  }

  anime(){
    let me = this;

    me.clearCanvas();

    me.y += me.speed;
    me.x += me.speed;

    // 縦
    if( me.y <= me.container.clientHeight * window.devicePixelRatio ){
      me.context.beginPath();
      for(let j=0; j<me.xLinePoint.length; j++){
        me.context.moveTo(me.xLinePoint[j], 0);
        me.context.lineTo(me.xLinePoint[j], me.y );
      }
      me.context.stroke();
    }
    else {
      me.ydraw();
    }

    // 横
    if( me.x <= me.container.clientWidth * window.devicePixelRatio ){
      me.context.beginPath();
      for(let j=0; j<me.yLinePoint.length; j++){
        me.context.moveTo(0, me.yLinePoint[j]);
        me.context.lineTo(me.y, me.yLinePoint[j]);
      }
      me.context.stroke();
    }
    else {
      me.xdraw();
    }


    if( me.y > me.container.clientHeight * window.devicePixelRatio
    && me.x > me.container.clientWidth * window.devicePixelRatio ){
      window.cancelAnimationFrame(me.animeReq);
    }
    else {
      me.animeReq = window.requestAnimationFrame( (e) => {
        me.anime();
      });
    }
  }

  ydraw(){
    let me = this;

    me.context.beginPath();
    for(let j=0; j<me.xLinePoint.length; j++){
      me.context.moveTo(me.xLinePoint[j],0);
      me.context.lineTo(me.xLinePoint[j], me.container.clientHeight * window.devicePixelRatio );
    }
    me.context.stroke();
  }

  xdraw(){
    let me = this;

    me.context.beginPath();
    for(let j=0; j<me.yLinePoint.length; j++){
      me.context.moveTo(0, me.yLinePoint[j]);
      me.context.lineTo(me.container.clientWidth * window.devicePixelRatio, me.yLinePoint[j]);
    }
    me.context.stroke();
  }

  draw(){
    let me = this;

    me.ydraw();
    me.xdraw();
  }

  clearCanvas(){
    let me = this;

    me.context.clearRect(0,0,me.canvas.clientWidth, me.canvas.clientHeight);   
  }

  clearPoint(){
    let me = this;

    me.xLinePoint = [];
    me.yLinePoint = [];
  }
}